import { render } from "./followCustom.vue?vue&type=template&id=7c89d193&scoped=true"
import script from "./followCustom.vue?vue&type=script&lang=js"
export * from "./followCustom.vue?vue&type=script&lang=js"

import "./followCustom.vue?vue&type=style&index=0&id=7c89d193&lang=scss&scoped=true"

import exportComponent from "/var/jenkins_home/workspace/edu-web/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7c89d193"]])

export default __exports__